import Turbolinks from 'turbolinks';
import delay from 'delay';

import axios from '@/helpers/axios';
import { isMobile } from '@/helpers/mobile_detect';

const REFRESH_INTERAL = 4000;

pageLoad('payments_qr', async () => {
  delay(REFRESH_INTERAL).then(processQrStatus);

  if (isMobile()) {
    const qrUrl = $('.qr-status').data('qr_url');

    if (qrUrl) {
      await delay(250);
      Turbolinks.visit(qrUrl);
    }
  }
});

async function processQrStatus() {
  const $container = $('.qr-status');
  const fetchUrl = $container.data('fetch_url');
  const redirectUrl = $container.data('redirect_url');

  if (fetchUrl) {
    const result = await axios.get(fetchUrl);

    $container.replaceWith(result.data.html);

    delay(REFRESH_INTERAL).then(processQrStatus);
  } else if (redirectUrl) {
    Turbolinks.visit(redirectUrl);
  }
}
